import 'bootstrap-sass/assets/javascripts/bootstrap/transition'
import 'bootstrap-sass/assets/javascripts/bootstrap/alert'
import 'bootstrap-sass/assets/javascripts/bootstrap/button'
import 'bootstrap-sass/assets/javascripts/bootstrap/collapse'
import 'bootstrap-sass/assets/javascripts/bootstrap/dropdown'
import 'bootstrap-sass/assets/javascripts/bootstrap/modal'
import 'bootstrap-sass/assets/javascripts/bootstrap/tooltip'
import 'bootstrap-sass/assets/javascripts/bootstrap/tab'
import 'simple-ajax-uploader'
import 'material-design-lite'
import $ from 'jquery'

//
// Bootstrap Tooltip
//

const whiteList = $.fn.tooltip.Constructor.DEFAULTS.whiteList
whiteList.dl = []
whiteList.dt = []
whiteList.dd = []
